/**
 * WordPress dependencies
 */
import { Modal } from '@wordpress/components';
import { withInstanceId } from '@wordpress/compose';
import { useState } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import classNames from 'classnames';

/**
 * Internal dependencies
 */
import ResLabelControl from '../res-label-control';
import ICONS from './icons';

// iconpicker control
const IconPickerControl = ({ label, value, onChange, help = '', instanceId }) => {
    const id = `icon-picker-control-${instanceId}`;

    const [iconsModal, setIconsModal] = useState(false);
    const [searchText, setSearchText] = useState('');

    return (
        <div className="progressmatify-control-container">
            <div className="progressmatify-mb-8">
                <ResLabelControl requiredProps={id} label={label} noResBtns={true} />
            </div>
            <div className="progressmatify-icons-wrapper">
                <button
                    className="progressmatify-icon-btn progressmatify-preview"
                    onClick={() => {
                        setIconsModal(true);
                    }}
                >
                    {ICONS[value]}
                </button>
            </div>
            {iconsModal && (
                <Modal
                    title={__('Progressmatify Blocks Icons', 'progressmatify-blocks')}
                    onRequestClose={() => setIconsModal(false)}
                    className="progressmatify-icons-modal"
                >
                    <div className="progressmatify-icons-search">
                        <input
                            type="text"
                            placeholder={__('Search Icons', 'progressmatify-blocks')}
                            value={searchText}
                            onChange={e => setSearchText(e.target.value)}
                        />
                    </div>
                    <div className="progressmatify-icons-list">
                        {searchText !== ''
                            ? Object.keys(ICONS)
                                  .filter(icon => icon.includes(searchText))
                                  .map((icon, index) => {
                                      return (
                                          <button
                                              key={index}
                                              onClick={() => {
                                                  onChange(icon);
                                                  setIconsModal(false);
                                              }}
                                              className={classNames('progressmatify-icon-btn', {
                                                  active: value === icon
                                              })}
                                          >
                                              {ICONS[icon]}
                                          </button>
                                      );
                                  })
                            : Object.keys(ICONS).map((icon, index) => {
                                  return (
                                      <button
                                          key={index}
                                          onClick={() => {
                                              onChange(icon);
                                              setIconsModal(false);
                                          }}
                                          className={classNames('progressmatify-icon-btn', {
                                              active: value === icon
                                          })}
                                      >
                                          {ICONS[icon]}
                                      </button>
                                  );
                              })}
                    </div>
                </Modal>
            )}
        </div>
    );
};

export default withInstanceId(IconPickerControl);
